import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../api'

const baseURL = `${baseAPI}/campaign`

export const QUERY_KEY = 'listCampaignGoals'

export const listCampaignGoals = () =>
  axios.get<GetCampaignGoalsResponse>(`${baseURL}/goals`)

export const getProductsRecommended = (publisherId: string) =>
  axios.get(`${baseURL}/product-recommendations`, {
    params: { publisher_id: publisherId }
  })
